<template>
<div id="mainBlock">
    <!-- エラー確認ポップアップの表示 -->
    <Alert
        ref="Alert"
        :message="alertMessage"
        :subMessage="alertSubMessage"
        :errorFlag="errorFlag"
        @confirmFinished="confirmFinished"
    />
    <!-- 変更確認ポップアップの表示 -->
    <Confirm
        ref="confirm"
        @cancel="modifyStatusDelete"
        @execution="modifyStatusChange"
        :message="confirmMessage"
        :subMessage="confirmSubMessage"
        :canselButtonName="confirmCancelMessage"
        :executionButtonName="confirmExecMessage"
    />
    <div id="blackPanel"></div>
    <article>
        <section>
            <!-- サブヘッダー -->
            <div id="subHeader" v-if="siteInfo !== null">
                <h2 v-if="siteInfo !== null">{{siteInfo[0]['site_name']}}</h2>
                <div class="controller">
                    <!-- 検索 -->
                    <div class="input_search">
                        <input type="text" v-model="searchCameraInfo" name="search" value="" placeholder="カメラ名を入力" class="search" />
                    </div>
                    <!-- カメラ選択 -->
                    <div class="input_search">
                        <select v-model="searchCameraInfo" class="search">
                            <option class="option-desc" value="" disabled="disabled" selected="selected" >カメラを選択</option>
                            <option v-for="(list, key) in cameraInfo" :key="key">{{list.description}}</option>
                        </select>
                    </div>
                    <!-- サイズ変更 -->
                    <div class="select_size">
                        <select name="view_size" class="size" v-model="selectedThumbnailSize" v-on:change="reseizeLiveTimeList()" id="select_size">
                            <option value="large">表示サイズ：大</option>
                            <option value="medium">表示サイズ：中</option>
                            <option value="small">表示サイズ：小</option>
                        </select>
                    </div>
                </div>
            </div>
        </section>
        <section>
            <!-- カメラリスト -->
            <div id="cameraList">
                <ul v-if="cameraInfo !== null">
                    <li class="clearfix" :class="selectedThumbnailSize" v-for="(list, key) in cameraInfo" :key="cameraInfo + key" :id="'show_' + list.term_id">
                        <div class="list_header">
                            <!-- 端末名 -->
                            <h3 class="home_thumbnail_head_name">{{list.description}}</h3>
                            <!-- カメラ直当たりURLのリンク -->
                            <div v-if="mainCamOperation" class="setting">
                                <a v-if="list.camera_host !== ''" :href="list.camera_host" target="_blank" @click.prevent.stop="settingMenu(list.camera_host)" rel="noopener noreferrer">
                                    <img src="../../assets/images/cam_setting.svg" alt="設定" />
                                </a>
                            </div>
                        </div>
                        <div class="list_body">
                            <!-- 1024px以下で表示されるローディングアイコン -->
                            <div v-if='list.camera_latest_thumbnail_snapshot_url !== "" && liveImg[list.term_id] == null' class="photo_list_sp loadDiv">
                                <img src="../../assets/images/loadingCircle.png" alt="" class="loadingCircle">
                            </div>
                            <!-- 1024px以下で表示するメニュバー -->
                            <div v-if="liveImg[list.term_id] != null" class="photo_list_sp">
                                <label class="take_day_label">撮影日時選択</label>
                                <select name="photo_list" :id="'select_thumbnail_' + list.term_id">
                                    <option
                                        v-for="(hour, key) in liveImg[list.term_id]"
                                        :key="liveImg[list.term_id] + key"
                                        :value="liveImg[list.term_id][key].datetime + ',' + liveImg[list.term_id][key].image_url_static"
                                    >
                                        {{liveImg[list.term_id][key].datetime | datetimeFormat}}
                                    </option>
                                </select>
                                <input type="submit" value="表示" @click="changeThumbnailSp(list.term_id)">
                            </div>
                            <!-- サムネ画像 -->
                            <div class="photo">
                                <!-- /sitesで取得した端末情報に含まれている最新のサムネイル画像を先に表示 -->
                                <img :id="'select_photo_' + list.term_id" :src='list.camera_latest_thumbnail_snapshot_url !== "" ? list.camera_latest_static_snapshot_url : require("../../assets/images/no_image.png")' @load="loaded(list.term_id)"/>
                            </div>
                            <!-- 日時に一致するサムネ画像の表示処理 -->
                            <div class="photo_list" :class="loadOperation">
                                <!-- APIでサムネイルURLと日時を取得するまでローディングを表示 -->
                                <div class="loadBox" v-show="loadFlagList[list.term_id] === true">
                                    <img :id="'loadImg_'+ list.term_id" class="loadImg" :src="loadingImg"/>
                                </div>
                                <!-- 日時リスト -->
                                <ul class="live_time_list" :id="'live_time_list_' + list.term_id" v-show="loadFlagList[list.term_id] === false">
                                    <li v-for="(hour, key) in liveImg[list.term_id]" :key="liveImg[list.term_id] + key">
                                        <a
                                            v-if="liveImg[list.term_id][key].image_url_static !== ''"
                                            href="javascript:;" :class="list.term_id"
                                            :id="'photo_' + list.term_id + '_' + liveImg[list.term_id][key].datetime"
                                            @click="changeThumbnail(list.term_id, liveImg[list.term_id][key].image_url_static, liveImg[list.term_id][key].datetime)"
                                        >
                                            {{liveImg[list.term_id][key].datetime | datetimeFormat}}
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </section>
    </article>
</div>
</template>
<script>
const apiUrl = process.env.VUE_APP_API_apiUrl;
const logoutUrl = process.env.VUE_APP_TOP_PAGE_URL;

import $ from 'jquery'// eslint-disable-line
import componentApiCheckThumbnail from '../../js/modules/componentApiCheckThumbnail.js'
import Alert from '../modal/Alert'
import Confirm from '../modal/Confirm'

export default {
    name: 'Main',
    data: function(){
        return {
            // サムネイルAPIで取得したデータ配列
            liveImg : {},
            // 検索ボックスに入力されたカメラ情報(端末名、グループ名、TAG)
            searchCameraInfo : '',
            // サムネAPIのURL
            url: null,
            // 時系列から選択したサムネイルの時刻を格納する配列
            lastLiveTime: {},
            // ページを開いた時に最新のサムネイルの時刻を格納する配列
            firstSelectTime: {},
            // ページを開いた時に最新のサムネイルの時刻が格納されているか判定するための配列
            is_firstSelectTime: {},
            // ウィンドウのサイズを保持するために使用
            width: window.innerWidth,
            // サムネイル画像の表示サイズを保持するために使用
            selectedThumbnailSize: 'medium',
            // 端末情報の表示/非表示を格納するための配列
            is_showCameraInfo: {},
            // ローディング画面を表示するための値
            is_show: false,
            // ローディング済みのサムネイルをカウントして格納
            loadedCount: 0,
            // APIをコールする際に一時的にバッファする
            infoCallingApi: null,
            infoCallingApiStatus: null,
            // 実行確認モーダル用のパーツ
            cameraUrl: '',
            settingFlag: false,
            confirmMessage: '',
            confirmSubMessage: '',
            confirmCancelMessage: '',
            confirmExecMessage: '',
            // アラートモーダル用のパーツ
            alertMessage: '',
            alertSubMessage: '',
            errorFlag: false,
            // 最終日時リストとオーバーレイの表示非表示を切り替えるFlagリスト
            loadFlagList: {},
            // /sitesと/termsのレスポンスを監視するための変数
            apiCnt: 0,
            // サムネ画像表示のカウント用変数（1枚目画像のみ違う処理を行うため）
            imgCnt: 0,
        }
    },
    props:{
        siteInfo:{
            type: Array
        },
        cameraInfo:{
            type: Array
        }
    },
    methods: {
        /**********************************************************/
        // 本日分(0:00~現在時刻まで10分刻み)のサムネイル画像一覧を取得するAPI実行処理
        /**********************************************************/
        // 引数
        // termId : 選択中の端末ID
        // siteNo : 端末グループNo
        /**********************************************************/
        getThumnailInfo: async function (siteNo, termId) {
            var now = new Date();
            var year = now.getFullYear();
            var mon = now.getMonth() + 1;
            var day = now.getDate();
            var hours = now.getHours();
            var time_start = year + '/' + mon + '/' + day + ' 00:00';
            var time_start_unixtime = Date.parse( time_start.replace( /-/g, '/') ) / 1000;
            var formatThumbnail = {};
            var queries = { live_access_token: this.$store.getters['auth/getLiveAccessToken'] };
            await this.$store.dispatch('requestApi/getApiInfoAction', {
                url: apiUrl + 'images/'+ siteNo +'/'+ termId +'/'+ time_start_unixtime + '/list',
                params: queries
            }).then(response => { //eslint-disable-line
                if (componentApiCheckThumbnail(this.$store.getters['requestApi/getApiInfo']) === true) {
                    // サムネの時間軸が降順になるように作成
                    for (var hour = hours; hour >= 0; hour--) {
                        if (this.$store.getters['requestApi/getApiInfo'][hour].sequence != 0) {
                            for (var i = this.$store.getters['requestApi/getApiInfo'][hour].sequence; i >= 1; i--) {
                                this.$set(formatThumbnail, hour + '_' + i, this.$store.getters['requestApi/getApiInfo'][hour][i]);
                            }
                        }
                    }

                    // 最新のサムネの撮影日と画像を取得
                    for (var hour2 = 0; hour2 <= hours; hour2++) {
                        if (this.$store.getters['requestApi/getApiInfo'][hour2].sequence != 0) {
                            for (var j = 1; j <= this.$store.getters['requestApi/getApiInfo'][hour2].sequence; j++) {
                                if (j == this.$store.getters['requestApi/getApiInfo'][hour2].sequence) {
                                    this.$set(this.lastLiveTime, termId, this.$store.getters['requestApi/getApiInfo'][hour2][j].datetime);
                                    this.$set(this.firstSelectTime, termId, 'photo_' + termId + '_' + this.$store.getters['requestApi/getApiInfo'][hour2][j].datetime);
                                    this.$set(this.is_firstSelectTime, termId, true);
                                }
                            }
                        }else {
                            this.$set(this.is_firstSelectTime, termId, true);
                        }
                    }
                    this.$set(this.liveImg, termId, formatThumbnail);
                    this.lastDateColor(termId);
                // 映像がなければ実行
                } else {
                    this.$set(this.is_firstSelectTime, termId, true);
                    this.$set(this.loadFlagList, termId, false);
                }
            }, error => { //eslint-disable-line
                if (error == "Error: Request failed with status code 401") {
                    sessionStorage.clear();
                    window.localStorage.removeItem('TodoApp');
                    this.showResultMessage({
                        transitionLogoutPageFlg: true,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"エラー",
                        sub_message:"トップページに戻ります。",
                        errorFlag: true
                    });
                } else if (error == "Error: Request failed with status code 403") {
                    this.showResultMessage({
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: true,
                        execFlg: false,
                        message:"権限エラー",
                        sub_message:"アクセス権がありません。",
                        errorFlag: true
                    });
                } else if (error == "Error: Request failed with status code 404") {
                    // 404が返ってくるパターンは、利用開始日前でauth_type_idがユーザー管理者とユーザー（端末管理者のとき）
                    // ローディングボックスをはずす処理を入れる
                    this.$set(this.loadFlagList, termId, false);
                } else {
                    this.$set(this.loadFlagList, termId, false);
                }
                this.$set(this.is_firstSelectTime, termId, true);
            })
        },
        /**********************************************************/
        // 最新日時にカラーを付け、日時取得ローディングを非表示にする
        /**********************************************************/
        lastDateColor: function(termId) {
            this.$nextTick(function () {
                if(this.cameraInfo !== null && this.is_firstSelectTime !== null){
                    if (this.is_firstSelectTime[termId] == true) {
                        if (this.firstSelectTime[termId] !== undefined) {
                            // 最新日時にカラーを付ける
                            document.getElementById(this.firstSelectTime[termId]).classList.add("active");
                            this.$set(this.loadFlagList, termId, false);
                        }
                    }
                }
            })
        },
        /**********************************************************/
        // 表示するサムネイルの時間帯を変更(スマホ版)
        /**********************************************************/
        // 引数
        // termId   : 選択中の端末ID
        /**********************************************************/
        changeThumbnailSp: function(termId) {
            // selectタブで選択された端末IDのunixtimeとサムネURLを分割して格納
            var selectThumbnailInfo = document.getElementById('select_thumbnail_' + termId).value.split(',');
            document.getElementById('select_photo_' + termId).src = selectThumbnailInfo[1];
            this.$set(this.lastLiveTime, termId, selectThumbnailInfo[0]);

            var targetElements = document.getElementsByClassName(termId);
            [].forEach.call(targetElements, function(elem) {
                elem.classList.remove('active');
            })
            document.getElementById('photo_' + termId + '_' + selectThumbnailInfo[0]).classList.add("active");
        },
        /**********************************************************/
        // 表示するサムネイルの時間帯を変更(PC版)
        /**********************************************************/
        // 引数
        // termId   : 選択中の端末ID
        // imageUrl : サムネイル用の画像のURL
        // datetime : サムネイル用の画像を撮影した時間
        /**********************************************************/
        changeThumbnail: function (termId, imageUrl, datetime) {
            document.getElementById('select_photo_' + termId).src = imageUrl;
            this.$set(this.lastLiveTime, termId, datetime);

            var targetElements = document.getElementsByClassName(termId);
            [].forEach.call(targetElements, function(elem) {
                elem.classList.remove('active');
            })
            document.getElementById('photo_' + termId + '_' + datetime).classList.add("active");
        },
        /**********************************************************/
        // 最新のサムネイルの高さを取得（最初のimgのロードが完了した時）
        /**********************************************************/
        // 引数
        // loadedCount：端末数の選択
        /**********************************************************/
        loaded: function(termId) {
            // imgの高さ取得
            var set_height = document.getElementById('select_photo_' + termId).height;
            // リストの高さを調整
            document.getElementById('live_time_list_' + termId).style.height = set_height + 'px';
            // IEかどうかの判定
            var userAgent = window.navigator.userAgent.toLowerCase();
            if(userAgent.indexOf('trident') != -1) {
                // IEの時の挙動
                // Boxの高さ - imgの高さ / 2 をmargin-topに追加する
                var margin_top = (set_height - document.getElementById('loadImg_' + termId).height) / 2;
                document.getElementById('loadImg_' + termId).style.marginTop = String(margin_top) +'px';
            }
        },
        /**********************************************************/
        // サムネイルの高さを取得（ウィンドウをリサイズした時）
        /**********************************************************/
        handleResize: function() {
            this.width = window.innerWidth;
            if (this.width >= 1024) {
                this.reseizeLiveTimeList();
            }
        },
        /**********************************************************/
        // サムネイルの表示サイズ変更時に時系列をリサイズ
        /**********************************************************/
        reseizeLiveTimeList: function() {
            // ビュー全体がレンダリングされるまで待つ
            this.$nextTick(function () {
                if(this.cameraInfo !== null){
                    for (var cam = 0; cam < this.cameraInfo.length; cam++) {
                        var termId = this.cameraInfo[cam].term_id;
                        var set_height = document.getElementById('select_photo_' + termId).height;
                        document.getElementById('live_time_list_' + termId).style.height = set_height + 'px';
                    }
                }
            })
        },
        /**********************************************************/
        // 表示サイズをクッキーに保存されているサイズに変更
        /**********************************************************/
        changeThumbnailSize: function(localStorage) {
            this.selectedThumbnailSize = localStorage;
        },
        //**********************************************************/
        // 確認モーダル用のデータの受け渡し
        /**********************************************************/
        showResultMessage(result) {
            this.$refs.Alert.showConfirm();
            this.alertMessage = result.message;
            this.alertSubMessage = result.sub_message;
            this.conrfirmResult = result
            this.errorFlag = result.errorFlag;
        },
        //**********************************************************/
        // 確認モーダル処理
        /**********************************************************/
        confirmFinished() {
            if (this.conrfirmResult.transitionLogoutPageFlg) {
                sessionStorage.clear();
                window.location.href = logoutUrl;
            }
            if (this.conrfirmResult.transitionTopPageFlg) {
                window.location.href = '/home?site_no=' + this.$store.getters['auth/getSiteNo'];
            }
            if (this.conrfirmResult.execFlg) {
                this.getThumnailImageInfo();
            }
        },
        /**********************************************************/
        // カメラ設定確認モーダルの表示
        /**********************************************************/
        settingMenu: function(url) {
            this.cameraUrl = url;
            this.settingFlag = true;
            this.confirmMessage = "カメラ設定";
            this.confirmSubMessage = "カメラ本体の設定画面へ遷移します。よろしいでしょうか？";
            this.confirmCancelMessage = "キャンセル";
            this.confirmExecMessage = "OK";
            this.$refs.confirm.showConfirm();
        },
        //**********************************************************/
        // 変更確認ポップアップの表示後、キャンセルを押した場合の処理
        /**********************************************************/
        modifyStatusDelete: function () {
            // 以下、カメラ直当たりへの画面遷移の有無状態を管理しているフラグを初期化する処理
            this.settingFlag = false;
            this.cameraUrl = '';
        },
        /**********************************************************/
        // モーダル確認後、カメラURLに遷移
        /**********************************************************/
        modifyStatusChange: function() {
            if (this.settingFlag === true) {
                window.open(this.cameraUrl, '_blank');
            }
            this.settingFlag = false;
            this.cameraUrl = '';
            this.$refs.confirm.hiddenConfirm();
        },
        /**********************************************************/
        // ページを開いたときに端末情報を全取得
        /**********************************************************/
        watchThumbnailInfo() {
            // 最終日時取得APIの実施
            if(this.cameraInfo !== null){
                for (var cam = 0; cam < this.cameraInfo.length; cam++) {
                    this.getThumnailInfo(this.cameraInfo[cam].site_no, this.cameraInfo[cam].term_id);
                }
            }
        },
        /**********************************************************/
        // クッキーに表示サイズが保存されているかチェック
        /**********************************************************/
        getLocalStrageThumbnailSize() {
            if (localStorage.getItem(this.siteInfo[0]['site_no'] + '_homeThumbnailSize') !== null) {
                this.changeThumbnailSize(localStorage.getItem(this.siteInfo[0]['site_no'] + '_homeThumbnailSize'));
            }
        },
    },
    computed: {
        /**********************************************************/
        // 日時取得部分のみロードを回すために
        // key = termId, value = trueを前もって格納し、ローディングを表示
        /**********************************************************/
        loadOperation() {
            for (var i = 0; i < this.cameraInfo.length; i++) {
                this.$set(this.loadFlagList, this.cameraInfo[i].term_id, true);
            }
            return '';
        },
        /**********************************************************/
        // IEとそれ以外のブラウザによって表示するロゴを切り替える(暫定)
        /**********************************************************/
        loadingImg() {
            var logo = '';
            var userAgent = window.navigator.userAgent.toLowerCase();
            if(userAgent.indexOf('trident') != -1) {
                // IEの時の挙動
                logo = require('../../assets/images/loader.gif');
            } else {
                logo = require('../../assets/images/loader.png');
            }
            return logo;
        },
        /**********************************************************/
        // 権限によるカメラ直当たりリンクの表示非表示
        /**********************************************************/
        mainCamOperation() {
            return this.$userRoleAuthorization('home', 'mainCamOperation');
        },
    },
    mounted: async function () {
        // 画面リサイズ時にサムネイルのおよび時系列が崩れないようにする
        window.addEventListener('resize', this.handleResize)
    },
    watch: {
        /**********************************************************/
        // /sitesと/termsのデータが入ってきたらカウント
        // どちらも応答が返ってきたら後続処理を実行する
        /**********************************************************/
        // cameraInfo：/sites（端末グループ情報）用の変数
        // siteInfo  ：/terms（端末情報）用の変数
        // apiCnt    ：apiレスポンスの監視用の変数
        /**********************************************************/
        cameraInfo: {
            handler: async function() {
                this.apiCnt++;
            },
            deep: true
        },
        siteInfo: {
            handler: async function() {
                this.apiCnt++;
            },
            deep: true
        },
        apiCnt: {
            handler: async function() {
                // /siteと/termsのデータが入った時に実行
                if(this.apiCnt === 2) {
                    this.getLocalStrageThumbnailSize();
                    // /imageの実行
                    this.watchThumbnailInfo();
                    // ローディング解除
                    this.$emit('loadFinish');
                }
            }
        },
        /**********************************************************/
        // 検索ボックスに入力した文字列に一致する端末情報を表示
        /**********************************************************/
        searchCameraInfo: {
            handler: function(){
                // ビュー全体がレンダリングされるまで待つ
                this.$nextTick(function () {
                    if(this.cameraInfo !== null){
                        for (var cam = 0; cam < this.cameraInfo.length; cam++) {
                            var termId = this.cameraInfo[cam].term_id;
                            var description = this.cameraInfo[cam].description;
                            document.getElementById('show_' + termId).style.display ="none";
                            if (this.searchCameraInfo === null) {
                                this.searchCameraInfo = '';
                            }
                            if(description.indexOf(this.searchCameraInfo) !== -1) {
                                document.getElementById('show_' + termId).style.display ="block";
                            }
                        }
                    }
                })
                this.reseizeLiveTimeList();
            },
            deep: true
        },
        /**********************************************************/
        // 表示サイズを変更時にクッキーに保存する（次回以降の初期表示用）
        /**********************************************************/
        selectedThumbnailSize: {
            handler: function(){
                // ビュー全体がレンダリングされるまで待つ
                this.$nextTick(function () {
                    localStorage.setItem(this.siteInfo[0]['site_no'] + '_homeThumbnailSize', this.selectedThumbnailSize)
                    // パネル全体の横幅を取得
                    for (var cam = 0; cam < this.cameraInfo.length; cam++) {
                        var get_panelWidth = "";
                        // largeのみ崩れてしまうので別処理を行う。
                        if(this.selectedThumbnailSize === "large" && this.imgCnt === 0) {
                            get_panelWidth = document.getElementById('show_' + this.cameraInfo[cam].term_id).clientWidth - 17;
                        } else {
                            get_panelWidth = document.getElementById('show_' + this.cameraInfo[cam].term_id).clientWidth;
                        }
                        // パネル全体の横幅（表示サイズごとに変動） - リストの横幅（180px） = 画像の横幅
                        // 画像本来の高さを取得
                        var get_height = document.getElementById('select_photo_' + this.cameraInfo[cam].term_id).naturalHeight;//no-imageなら360, 画像あれば480
                        var get_width = document.getElementById('select_photo_' + this.cameraInfo[cam].term_id).naturalWidth;//640
                        // リストの横幅
                        var list_width = 180;
                        // 表示したい画像サイズ(パネル全体の横幅 - 日時リストの横幅) / 画像サイズで画像の拡大、縮小率を求め、高さに掛ける
                        var set_height = ((get_panelWidth - list_width) / get_width) * get_height;
                        // リストの高さを調整した画像の高さに設定
                        document.getElementById('live_time_list_' + this.cameraInfo[cam].term_id).style.height = set_height + 'px';
                    }
                    this.imgCnt++;
                })
            },
            deep: true
        }
    },
    beforeDestroy: function () {
        // 画面リサイズ時にサムネイルのおよび時系列が崩れないようにする
        window.removeEventListener('resize', this.handleResize)
    },
    filters: {
        /**********************************************************/
        // サムネイルの上のタイトルおよび右の時系列の日時をフォーマット 
        /**********************************************************/
        datetimeFormat: function(unixtime){
            var dateTime = new Date(unixtime * 1000);
            var year = dateTime.getFullYear();
            var mon = dateTime.getMonth() + 1;
            var day = dateTime.getDate();
            var hour = ( dateTime.getHours()   < 10 ) ? '0' + dateTime.getHours()   : dateTime.getHours();
            var min  = ( dateTime.getMinutes() < 10 ) ? '0' + dateTime.getMinutes() : dateTime.getMinutes();
            return year + '/' + mon + '/' + day + ' ' + hour + ':' + min;
        }
    },
    components: {
        Alert,
        Confirm,
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/main/Main.css";
</style>